<script setup lang="ts">
import { onMounted } from "vue";
import AccountNav from "./AccountNav.vue";
import { useCompanyKyc } from "../../composables/useCompanyKyc";

// The navigation needs the account type (Verification is business-only) and
// the verification state for its flag; both come from GET /kyc.
const { load } = useCompanyKyc();
onMounted(() => void load());
</script>

<template>
  <div class="ac-page">
    <header class="ac-header">
      <div class="ac-inner">
        <h1 class="ac-title">Account</h1>
        <p class="ac-subtitle">Your profile, sign-in and company details</p>
      </div>
    </header>

    <div class="ac-inner ac-body">
      <AccountNav />
      <main class="ac-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<style>
/* Account pages share styles/account.scss. The face is loaded here, once for
   the section, rather than by every page as the old standalone pages did. */
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap");
</style>
